import * as Yup from "yup";
import { validaCpf } from "../../../../utils/validations";

export const modalAddDependentSchema = Yup.object({
  nome: Yup.string()
    .required(`Nome obrigatório`)
    .test("lastName", "Insira pelo menos um sobrenome", (name) => {
      if (!name) {
        return false;
      }
      const formattedName = name.trim().split(" ");
      return formattedName?.length > 1;
    }),

  nomeSocial: Yup.string()
    .min(3, "O nome social deve ter no mínimo 3 caracteres.")
    .max(80, "O nome social deve ter no máximo 80 caracteres.")
    .nullable()
    .optional(),

  dataNascimento: Yup.string()
    .required(`Data nascimento obrigatório`)
    .test("dataNascimento", "A data de nascimento é inválida", (value) => {
      if (!value) return false;
      const dateFormated = value.replace(/_/g, "").replace(/\//g, "-");
      if (dateFormated.length < 10) return false;
      const dateParts = dateFormated.split("-");
      // eslint-disable-next-line radix
      if (parseInt(dateParts[1]) > 12 || parseInt(dateParts[0]) > 31)
        return false;
      const formattedDateStr = dateParts.reverse().join("-");
      const birthDate = new Date(formattedDateStr);
      const currentDate = new Date();
      if (birthDate >= currentDate) {
        return false;
      }
      return true;
    }),
  cpf: Yup.string()
    .required(`Cpf obrigatório`)
    .test("cpf", "O CPF é inválido", (value) => {
      if (!value) return false;
      const cpfFormated = value.split(".").join("").replace("-", "");
      return validaCpf(cpfFormated);
    }),
  sexo: Yup.string().required(`Sexo obrigatório`),
  grauParentesco: Yup.string().required(`Grau de parentesco obrigatório`),
  nomeMae: Yup.string().required(`Nome da mãe obrigatório`),
  area: Yup.string()
    .required(`DDD obrigatório`)
    .min(2, "DDD inválido")
    .max(2, "DDD inválido")
    .matches(/^[0-9]+$/, "O campo deve conter apenas números"),
  telefone: Yup.string()
    .required(`Telefone obrigatório`)
    .nullable()
    .matches(/^[0-9]+$/, "O campo deve conter apenas números")
    .min(8, "O telefone é inválido")
    .max(10, "O telefone é inválido"),
});
